/**
 * Telefon alanı — Türkiye numarası için maskeli `Alan`.
 *
 * Kullanıcı ne yazarsa yazsın ("5…", "0532…", "+90 532…", yapıştırılmış
 * "905321110001") alan `0532 111 00 01` biçimine oturur; bu, listelerde
 * gösterilen biçimle aynıdır. İndirgeme kuralı `@kantin/shared` içindedir ve
 * API ile ortaktır; burada yalnızca yazım anı ele alınır.
 *
 * `onChange` DOM olayı değil maskelenmiş dizeyi verir: çağıranın olay
 * nesnesinden değer çıkarıp yeniden maskelemesi gerekmesin.
 */
import { forwardRef } from "react";
import { TELEFON_ORNEK, telefonMaske } from "@kantin/shared";
import { Alan, type AlanOzellikleri } from "./temel.js";

export interface TelefonAlaniOzellikleri extends Omit<
  AlanOzellikleri,
  "value" | "onChange" | "type" | "inputMode"
> {
  value: string;
  onChange: (deger: string) => void;
}

export const TelefonAlani = forwardRef<
  HTMLInputElement,
  TelefonAlaniOzellikleri
>(function TelefonAlani({ value, onChange, ipucu, ...kalan }, ref) {
  return (
    <Alan
      ref={ref}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder={TELEFON_ORNEK}
      value={value}
      onChange={(e) => onChange(telefonMaske(e.target.value))}
      ipucu={ipucu ?? `Örnek: ${TELEFON_ORNEK}`}
      {...kalan}
    />
  );
});
